import { _ as _slicedToArray } from '../slicedToArray-45a33045.js';
import { jsx, Fragment, jsxs } from '@emotion/react/jsx-runtime';
import { useRef, useState, useLayoutEffect } from 'react';
import { Dropdown } from './Dropdown.js';
import '../unsupportedIterableToArray-5baf4325.js';
import '../defineProperty-1e8516b1.js';
import '@emotion/styled/base';
import './Overlay.js';
import 'react-dom';
import './TabOutlineController.js';
import '../utils/hooks.js';
import '../typeof-64325575.js';
import 'axios';
import '@emotion/react';
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "je8g23",
  styles: "pointer-events:none"
} : {
  name: "1q5tilr-css",
  styles: "pointer-events:none;label:css;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Tooltip = function Tooltip(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? 'tooltip' : _ref2$className,
    children = _ref2.children,
    onHover = _ref2.onHover,
    _ref2$distance = _ref2.distance,
    distance = _ref2$distance === void 0 ? 0 : _ref2$distance,
    alignTop = _ref2.alignTop,
    alignBottom = _ref2.alignBottom,
    alignRight = _ref2.alignRight,
    text = _ref2.text,
    alignCenter = _ref2.alignCenter,
    positionRight = _ref2.positionRight,
    positionLeft = _ref2.positionLeft;
  var tooltipRef = useRef(null);
  var _useState = useState(!onHover),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var onMouseEnter = function onMouseEnter() {
    setVisible(true);
  };
  var onMouseLeave = function onMouseLeave() {
    setVisible(false);
  };
  useLayoutEffect(function () {
    var element = tooltipRef.current;
    if (!onHover || !element) {
      return undefined;
    }
    element.addEventListener('mouseenter', onMouseEnter);
    element.addEventListener('mouseleave', onMouseLeave);
    return function () {
      element.removeEventListener('mouseenter', onMouseEnter);
      element.removeEventListener('mouseleave', onMouseLeave);
    };
  }, []);
  return jsx(Fragment, {
    children: jsxs("div", {
      ref: tooltipRef,
      children: [children, visible && jsx(Dropdown, {
        className: className,
        parentRef: tooltipRef,
        alignTop: alignTop,
        alignCenter: alignCenter,
        alignRight: alignRight,
        positionRight: positionRight,
        positionLeft: positionLeft,
        alignBottom: alignBottom,
        distance: distance,
        grow: true,
        shrink: true,
        css: _ref,
        children: text
      })]
    })
  });
};
export { Tooltip };